import type { ClientItemId } from 'owa-client-ids';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { useComputedValue } from 'owa-react-hooks/lib/useComputed';

export default function useRowIdToShowInReadingPane(
    rowKey: string | undefined,
    tableView: TableView | undefined
): ClientItemId | undefined {
    return useComputedValue(
        () =>
            rowKey && tableView
                ? MailRowDataPropertyGetter.getRowIdToShowInReadingPane(rowKey, tableView)
                : undefined,
        [rowKey, tableView]
    );
}
